import React, { useState } from "react";

import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../context/StateContext";
import { WidgetFilter } from "../../../../models/widget.filter";
import DashboardService from "../../../../services/dashboard.service";
import { formatThousandsWithComma } from "../../../../util/formatThousandsWithComma";
import { useStyles } from "./styles";

type Props = {
  widgetFilter?: WidgetFilter;
};

/** Default Functional Component */
export default function ActiveContainers(props: Props) {
  const { widgetFilter } = props;

  const classes = useStyles();
  const { currentUser } = useAppState();

  const { t: translate } = useTranslation();

  const [total, setTotal] = useState<number>(0);

  useQuery(
    ["dashboard.container.active.count", widgetFilter],
    () =>
      DashboardService.getContainerActiveCount({
        dateFrom: widgetFilter?.dateFrom,
        dateTo: widgetFilter?.dateTo,
        companyId: currentUser?.companyId,
      }),
    {
      onSuccess: (response) => {
        if (response && response?.data !== undefined && !Number.isNaN(Number(response?.data))) {
          setTotal(response?.data);
        }
      },
      enabled: !!currentUser?.companyId,
    }
  );

  return (
    <Box data-cy="activeContainerBox" className={classes.root}>
      <Typography className={classes.title} gutterBottom data-cy="activeContainers">
        {translate("activeContainers")}
      </Typography>

      <Typography
        className={classes.lblFigures}
        variant="h5"
        component="h2"
        align="left"
        data-cy="activeContainersTotal"
      >
        {formatThousandsWithComma(String(total))}
      </Typography>
    </Box>
  );
}
